// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zZ96","input":"styles_input__2KwZR"};